module.exports = __webpack_public_path__ + "img/blueArrow.70224b80.svg";